<template>
  <div>
    <input
      :class="inputClass"
      v-bind="$attrs"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      @focus="showInfo = true"
      @blur="showInfo = false"
    />
    <p v-show="showInfo" :class="infoClass">
      {{ info }}
    </p>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: [
    "info",
    "inputClass",
    "infoClass",
    // Usado para que funcione v-model
    "value",
  ],
  data() {
    return {
      showInfo: false,
    };
  },
};
</script>